<template>
  <v-resource-list
    :loading="loading"
    :items="items"
    :show-view="showView"
    :show-edit="showEdit"
    :show-delete="showDelete"
    :show-attach="showAttach"
    @paginate="fetchResource"
    @viewResource="viewResource"
    @editResource="editResource"
    @deleteResource="deleteResource"
  >
    <template slot="headings">
      <th class="text-left">Page Type</th>
      <th class="text-left">Site</th>
      <th class="text-left">Language</th>
      <th v-if="!exclude.includes('entities')" class="text-left">Entities</th>
      <th class="text-left">Status</th>
      <th class="text-left">WP Status</th>
      <th class="text-left">Core</th>
      <th class="text-left">SEO Approved</th>
      <th class="text-left">Content Approved</th>
    </template>
    <template slot-scope="{ item }">
      <td>
        <router-link
          :to="{
            name: 'page-types.manage',
            params: { id: get(item, 'pageType.id', get(item, 'page.page_type_id')) },
          }"
        >
          {{ get(item, 'pageType.name', get(item, 'page.page_type_id')) }}
        </router-link>
      </td>
      <td>
        <router-link :to="{ name: 'sites.edit', params: { id: get(item, 'site.id', get(item, 'page.site_id')) } }">
          {{ get(item, 'site.name', get(item, 'page.site_id')) }}
        </router-link>
      </td>
      <td>
        <router-link
          :to="{
            name: 'languages.view',
            params: { id: get(item, 'language.id', get(item, 'page.language_id')) },
          }"
        >
          {{ get(item, 'language.name', get(item, 'page.language_id')) }}
        </router-link>
      </td>
      <td v-if="!exclude.includes('entities')">
        <router-link
          v-for="entity in get(item, 'entities', [])"
          :key="entity.id"
          :to="{ name: 'entities.manage', params: { id: entity.id } }"
        >
          {{ entity.entity.default.name }}
        </router-link>
      </td>
      <td>{{ get(item, 'status', get(item, 'page.status')) }}</td>
      <td>{{ get(item, 'wp_status', get(item, 'page.wp_status')) }}</td>
      <td>
        <tick-or-cross :value="new Boolean(get(item, 'is_core', get(item, 'page.is_core', false)))" />
      </td>
      <td>
        <tick-or-cross :value="new Boolean(get(item, 'seo_approved', get(item, 'page.seo_approved', false)))" />
      </td>
      <td>
        <tick-or-cross :value="new Boolean(get(item, 'content_approved', get(item, 'page.content_approved', false)))" />
      </td>
    </template>
  </v-resource-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ListResourceHandler from '@/mixins/list-resource-handler'
export default {
  mixins: [ListResourceHandler],
  props: {
    exclude: {
      type: Array,
      default: () => [],
    },
    showView: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    showAttach: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      entityPages: 'entityPages/getEntityPages',
      pages: 'pages/getPages',
    }),
  },
  methods: {
    ...mapActions({
      fetchEntityPages: 'entityPages/fetch',
      fetchPages: 'pages/fetch',
      deleteEntityPages: 'entityPages/detach',
      deletePages: 'pages/delete',
    }),
    viewResource(item) {
      this.$router.push({ name: 'content.pages.view', params: { id: item.id || item.page.id || null } })
    },
    editResource(item) {
      this.$router.push({ name: 'content.pages.edit', params: { id: item.id || item.page.id || null } })
    },
  },
}
</script>
